<ng-container *ngIf="navigationItems && initialized">
    @if (activeNavigationItem?.action == 'creditor') {
        <bm-creditor-basic-data-component [creditorId]="objectIdentifier.objectId"></bm-creditor-basic-data-component>
    }

    @if (activeNavigationItem?.action == 'creditor.bank.account') {
        <bm-creditor-bank-account-details [creditorId]="objectIdentifier.objectId"></bm-creditor-bank-account-details>
    }

    @if (activeNavigationItem?.action == 'creditor.camt.upload') {
        <bm-creditor-camt-upload [creditorId]="objectIdentifier.objectId"></bm-creditor-camt-upload>
    }

    @if (activeNavigationItem?.action == 'creditor.camt.imports') {
        <bm-creditor-camt-imports [creditorId]="objectIdentifier.objectId"></bm-creditor-camt-imports>
    }

    @if (activeNavigationItem?.action == 'creditor.transaction.analysis') {
        <bm-creditor-transaction-analysis [creditorId]="objectIdentifier.objectId"></bm-creditor-transaction-analysis>
    }
</ng-container>

